import Handlebars from 'handlebars'
const templateString=`<div style="border: 0px none;  display: inline-block;">
  <a href="{{defaultValue @root.contact.url 'contact.url'}}/collections/{{share.id}}"  
    data-widget-placeholder="\{{contact.url}}/collections/\{{share.id}}" 
    style="color: {{defaultValue theme.primaryColor "#E51058"}};
    border: 0px none;
    display: inline-block;
    outline: none;
    text-decoration: none;">View Content</a>
</div>`

const template = Handlebars.compile(templateString)

export default template